import React, { useRef, useCallback } from 'react';

import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';

import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';

import { useReactToPrint } from 'react-to-print';
import { Dropdown } from 'react-bootstrap';

import LogicContext from '../../Context/LogicContext';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { ImAttachment } from 'react-icons/im';
import { FaFilePdf } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import { IoPrintSharp } from 'react-icons/io5';
import PackageScroll from './PackagesScroll';
import PackageDetailsContent from './PackageDetailContent';
import { packageService } from '../../services/packageService';
import { SetPackageEditAtom, GetPackageListAtom, SetPackageListAtom } from '../../store/packageStore';
import { Button, Modal } from 'antd';
import { toLowercaseKeys } from '../../helpers/toLowerCaseKeys';
import SalesOrderAddressModal from '../sales_order/SalesOrderAddressModal';

const PackageDetailsPage = () => {
  const myPromiseModal = createModal(GeneralModal);
  const getPackageAtomList = GetPackageListAtom();
  const setPackageAtomList = SetPackageListAtom();
  const setPackageEditAtom = SetPackageEditAtom();
  const logicContext = useContext(LogicContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');

  const { id } = useParams();
  const navigate = useNavigate();
  const [packageDetails, setPackageDetails] = useState({});
  const [actionData, setActionData] = useState({});
  const [packageList, setPackageList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { pathname } = useLocation();
  const [addressModal, setAddressModal] = useState(false);

  var url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const mountRef = useRef(false);
  const componentRef = useRef();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  // Use useCallback to memoize the function
  const getPackageDetails = useCallback(
    packageId => {
      packageService.packageDetails(packageId).then(res => {
        const normalizedData = toLowercaseKeys(res?.data);
        const actionDataFromServer = normalizedData?.sales_order_action?.[0];
        if (normalizedData?.sales_order_details?.length) {
          const newDetails = normalizedData?.sales_order_details?.[0];
          setPackageList(normalizedData?.sales_order_details);
          setPackageDetails(newDetails);

          const tempList = getPackageAtomList[type];
          if (tempList?.length) {
            const newList = tempList.map(pkg => {
              if (pkg.package_slip === newDetails?.package_slip) {
                return newDetails;
              } else {
                return pkg;
              }
            });
            setPackageAtomList(prev => {
              return { ...prev, [type]: newList };
            });
          }
        } else {
          setPackageList([]);
          setPackageDetails({});
        }

        if (actionDataFromServer) {
          setActionData(actionDataFromServer);
        } else {
          setActionData({});
        }
      });
    },
    [type]
  ); // Only depend on 'type', not on getPackageAtomList or setPackageAtomList

  useEffect(() => {
    document.title = ' Package Details';
    mountRef.current = true;
    getPackageDetails(id);

    return () => {
      mountRef.current = false;
    };
  }, [id, getPackageDetails]);

  const editPackage = async () => {
    if (packageDetails.sales_order_status_id !== 4 && packageDetails.sales_order_status_id !== 5) {
      return logicContext.showToast('Only CONFIRMED or NOT SHIPPED item can be modified!', 'error');
    }
    const response = await myPromiseModal({
      title: 'Modify Package',
      body: ' Do you want to modify this record?',
      showInput: false,
      placeHolder: '',
    });

    if (response.decision === true) {
      setPackageEditAtom(packageList);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };

  const markAsShipped = async () => {
    if (packageDetails.sales_order_status_id !== 5) {
      return logicContext.showToast('Only NOT SHIPPED item can be modified!', 'error');
    }
    const response = await myPromiseModal({
      title: 'Ship item manually',
      body: `Package with ${packageDetails.sales_order_no} will marked as shipped? `,
      showInput: false,
      placeHolder: '',
    });

    if (response.decision === true) {
      setPackageEditAtom(packageList);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new-shipping`);
    }
  };



  const deletePackage = async () => {
    const response = await myPromiseModal({
      title: 'Delete Package',
      body: `Package with ${packageDetails?.sales_order_no} will be deleted.`,
      showInput: false,
      placeHolder: '',
    });

    if (response.decision === true) {
      packageService
        .deletePackage(packageDetails?.sales_order_ref_no)
        .then(res => {
          const { message_text, message_id } = res.data[0];

          const tempList = getPackageAtomList[type];
          if (tempList?.length) {
            const newList = tempList.filter(lst => lst.sales_order_ref_no !== packageDetails?.sales_order_ref_no);
            setPackageAtomList(prev => {
              return { ...prev, [type]: newList };
            });
          }
          logicContext.showToast(message_text, '');
          sessionStorage.setItem('reloadPage', 'true');
          navigate(-1);
        })
        .catch(err => {
          console.log('del_error ', err);
        });
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmitFormMarkDelivered = async () => {
    const formData = getValues();
    const newForm = { ...formData, sales_order_ref_no: packageDetails?.sales_order_ref_no, option: 19 };
    packageService
      .deliveredPackage(newForm)
      .then(res => {
        setIsModalOpen(false);

        const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
        const { message_id, message_text } = cleanResponse;
        if (message_id == 1) {
          logicContext.showToast(message_text, 'success');
          sessionStorage.setItem('reloadPage', 'true');
          getPackageDetails(id);
        }
      })
      .catch(err => {
        console.log('err ', err);
      });
  };



  const actionManager = async (option, actionName) => {
    const response = await myPromiseModal({
      title: 'Please confirm your action',
      body: `Package will be marked as ${actionName} .`,
      showInput: false,
      showDate: option === 16 ? true : false,
      placeHolder:option === 16 ? 'Please select SHIPING date(required)' : '',
    });


    if (response.decision === false) {
      return;
    }

      if (option === 13) { // tO BE PACKAGE
      setPackageEditAtom(packageList);
      return navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new?option=${option}`);
    }

    if (option === 16 && !response.date) {
      return logicContext.showToast('Please select SHIPING date! (required)', '');
    }

   const newForm = {
  sales_order_ref_no: packageDetails?.sales_order_ref_no,
  option: option,
  ...(option=== 16 && { shipment_delivery_date:response.date.replace('T', ' ') })};
    packageService .deliveredPackage(newForm).then(res => {
        setIsModalOpen(false);
        getPackageDetails(id);
        const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
        const { message_id, message_text } = cleanResponse;
        if (message_id == 1) {
          logicContext.showToast(message_text, 'success');
        }
      })
      .catch(err => {
        console.log('err ', err);
      });
  };


  return (
    <>
      <SalesOrderAddressModal
        saleId={packageDetails?.sales_order_ref_no}
        isOpen={addressModal}
        defaultData={{
          country: packageDetails?.order_recipient_shipping_country_id,
          city: packageDetails?.order_recipient_shipping_city_id,
          area: packageDetails?.order_recipient_shipping_area_id,
          addressLine: packageDetails?.order_recipient_shipping_address_line_one,
          zip_code: packageDetails?.order_recipient_shipping_zip_code,
        }}
        onClose={() => setAddressModal(false)}
        reload={() => getPackageDetails(id)}
      />
      <>
        <Modal title="Mark as Delivered" open={isModalOpen} onOk={onSubmitFormMarkDelivered} onCancel={handleCancel}>
          <div className="flex space-x-4">
            <div className="flex flex-col">
              <label htmlFor="date" className="text-gray-700 mb-1">
                Date
              </label>
              <input
                {...register('shipment_delivery_date')}
                type="date"
                id="date"
                className="border border-gray-300 rounded-md px-3 py-2 
           w-32 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="time" className="text-gray-700 mb-1">
                Time
              </label>
              <input
                {...register('shipment_delivery_time')}
                type="time"
                id="time"
                className="border border-gray-300 
          rounded-md px-3 py-2  w-32 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
        </Modal>
      </>

      <section className="mt-2">
        <section className="w-full">
          <div className="flex flex-row items-center justify-end"> 
            {actionData?.procedure_option && (
              <>
                <Dropdown className=" mr-3">
                  <Dropdown.Toggle className="text-sm text-white bg-[#476EF8]" id="dropdown-basic">
                    ACTION
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="mt-1 shadow-xl border-[1px] border-gray-200 rounded-md bg-white">
                    <Dropdown.Item
                      className="border-1 active:bg-gray-200"
                      onClick={() => actionManager(actionData?.procedure_option, actionData?.action_name)}
                    >
                      <div className=" text-sm text-gray-600 py-[2px] hover:bg-100">{actionData?.action_name}</div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            )}

            <div className="flex fle-row items-center space-x-1 ">
              <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <ImAttachment className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
              </div>

              <div onClick={() => handlePrint()} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <FaFilePdf className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
              </div>

              <div onClick={() => handlePrint()} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <IoPrintSharp className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
              </div>
              <div onClick={editPackage} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <MdEdit className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
              </div>
              <div onClick={() => deletePackage()} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <MdDelete className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
              </div>
            </div>
          </div>

          <section className="mt-4 lg:flex space-x-1">
            <div className="lg:w-[210px]">
              <PackageScroll />
            </div>
            {/* Body product */}
            <PackageDetailsContent setAddressModal={() => setAddressModal(true)} packageList={packageList} packageDetails={packageDetails} />

            {/* Body product end */}
          </section>
        </section>
      </section>
    </>
  );
};

export default PackageDetailsPage;
